import { useMemo } from 'react';
import { selector, useRecoilState, useRecoilValue } from 'recoil';
import {
  dashboardsLoadedState,
  dashboardsState,
  externalDashboardQueriesState,
  externalDashboardsState,
  groupDashboardQueriesState,
  isPublicViewState,
  isSharedState
} from '../../store/dashboardsAtoms';

const mappedOverviewQueriesSelector = selector({
  key: 'mappedOverviewQueriesSelector',
  get: ({ get }) => {
    const groupDashboardQueries = get(groupDashboardQueriesState);
    const externalDashboardQueries = get(externalDashboardQueriesState);

    const allQueries = [...groupDashboardQueries, ...externalDashboardQueries];

    return new Map(
      allQueries.map((query) => {
        const answer = JSON.parse(query?.answer || '{}')?.answer || '';
        if (query.title === 'Digest') {
          return [
            `${query.dashboardId}:${query.title}`,
            answer.split(',').map((split: any) => split.trim()),
          ];
        }
        return [`${query.dashboardId}:${query.title}`, answer];
      })
    );
  },
});

const useDashboardsContext = () => {
  const [dashboardsLoaded, setDashboardsLoaded] = useRecoilState(dashboardsLoadedState);
  const [dashboards, setDashboards] = useRecoilState(dashboardsState);
  const [externalDashboards, setExternalDashboards] = useRecoilState(externalDashboardsState);
  const [groupDashboardQueries, setDashboardsQueries] = useRecoilState(groupDashboardQueriesState);
  const [externalDashboardQueries, setExternalDashboardQueries] = useRecoilState(externalDashboardQueriesState);
  const [isPublicView, setIsPublicView] = useRecoilState(isPublicViewState);
  const [isShared, setIsShared] = useRecoilState(isSharedState);
  const mappedOverviewQueries = useRecoilValue(mappedOverviewQueriesSelector);

  const context = useMemo(() => ({
    dashboardsLoaded,
    dashboards,
    externalDashboards,
    dashboardsQueries: groupDashboardQueries,
    externalDashboardQueries,
    mappedOverviewQueries,
    isPublicView,
    isShared,
    setDashboardsLoaded,
    setDashboards,
    setExternalDashboards,
    setDashboardsQueries,
    setExternalDashboardQueries,
    setIsPublicView,
    setIsShared,
  }), [
    dashboardsLoaded,
    dashboards,
    externalDashboards,
    groupDashboardQueries,
    externalDashboardQueries,
    mappedOverviewQueries,
    isPublicView,
    isShared,
    setDashboardsLoaded,
    setDashboards,
    setExternalDashboards,
    setDashboardsQueries,
    setExternalDashboardQueries,
    setIsPublicView,
    setIsShared,
  ]);

  return context;
};

export default useDashboardsContext;